// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3b729bcc","inlineWrapper":"_6a2775a5","star":"_1dcec20b","small":"_43c9cf40","medium":"_ffb71962","selectable":"_eca424fd"};